module.exports = fox._r("fonts/robotoslab-regular-webfont.svg", __webpack_public_path__ + "fonts/robotoslab-regular-webfont.svg");


//////////////////
// WEBPACK FOOTER
// ./fonts/robotoslab-regular-webfont.svg
// module id = 589
// module chunks = 2